import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

interface WrapperProps {
  centered?: boolean;
  noMargin?: boolean;
  hugRight?: boolean;
  height?: string;
}

const Wrapper = styled.div<WrapperProps>`
  font-family: "Righteous";
  font-size: 2.2rem;
  padding: ${(props) => props.theme.spacing.medium};

  a {
    display: flex;
    color: ${(props) => props.theme.colors.textPrimary};
    text-decoration: none;
    height: 51px;
    align-items: center;
  }

  ${(props) =>
    props.noMargin &&
    css`
      margin-top: 0;
    `}

  ${(props) =>
    props.centered &&
    css`
      text-align: center;
    `}

    ${(props) =>
    props.hugRight &&
    css`
      padding-right: 0;
    `}

  svg {
    display: block;
    height: ${(props) => props.height || "auto"};
    max-height: 28px;
    max-width: 100%;

    path {
      fill: ${(props) => props.theme.colors.textPrimary};
    }
  }
`;

interface Props {
  centered?: boolean;
  noMargin?: boolean;
  hugRight?: boolean;
  height?: string;
}

const Logo: React.FC<Props> = ({ centered, noMargin, hugRight, height }) => {
  return (
    <Wrapper
      centered={centered}
      noMargin={noMargin}
      hugRight={hugRight}
      height={height}
    >
      <Link to="/" aria-label="Gå til forsiden">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          viewBox="0 0 1159 267"
        >
          <path d="M116.19 180.34H86v52H30.64V36.63h89.47c17.71 0 33.08 2.94 46.13 8.81 13.04 5.87 23.11 14.26 30.2 25.16 7.08 10.9 10.62 23.72 10.62 38.44 0 14.17-3.31 26.52-9.93 37.05-6.62 10.53-16.08 18.78-28.38 24.74l42.22 61.51H151.7l-35.51-52zm26.29-92.54c-5.78-5.03-14.36-7.55-25.72-7.55H86v57.32h30.76c11.37 0 19.94-2.47 25.72-7.41 5.78-4.94 8.67-11.97 8.67-21.11-.01-9.13-2.9-16.22-8.67-21.25zM258.64 212.5c-16.12-15.84-24.19-38.3-24.19-67.38V36.63h55.36v106.8c0 31.31 12.39 46.97 37.19 46.97 24.6 0 36.91-15.66 36.91-46.97V36.63h54.52v108.48c0 29.08-8.06 51.54-24.18 67.38-16.12 15.85-38.72 23.77-67.8 23.77s-51.69-7.92-67.81-23.76zM633.44 148.61c6.33 8.3 9.51 18.31 9.51 30.06 0 17.15-6.9 30.38-20.69 39.7-13.8 9.32-33.74 13.98-59.83 13.98h-105.7V36.63h100.09c24.98 0 43.99 4.61 57.04 13.84 13.04 9.23 19.57 21.67 19.57 37.33 0 9.32-2.29 17.66-6.85 25.02-4.57 7.37-11.04 13.19-19.43 17.47 11.19 3.92 19.95 10.03 26.29 18.32zm-121.9-72v37.74h38.02c18.64 0 27.96-6.33 27.96-19.01 0-12.49-9.32-18.73-27.96-18.73h-38.02zm75.49 95.9c0-13.23-9.69-19.85-29.08-19.85h-46.41v39.7h46.41c19.38.01 29.08-6.61 29.08-19.85zM672.58 36.63h55.36v195.71h-55.36V36.63zM810 223.26c-16.31-8.67-29.13-20.73-38.44-36.21-9.32-15.47-13.98-32.99-13.98-52.56s4.66-37.09 13.98-52.56c9.32-15.47 22.13-27.54 38.44-36.21 16.31-8.67 34.71-13 55.22-13 17.89 0 34.01 3.17 48.37 9.51 14.35 6.34 26.28 15.47 35.79 27.4l-35.23 31.87c-12.68-15.28-28.06-22.93-46.13-22.93-10.62 0-20.09 2.33-28.38 6.99-8.3 4.66-14.73 11.23-19.29 19.71-4.57 8.48-6.85 18.22-6.85 29.22s2.28 20.74 6.85 29.22 11 15.05 19.29 19.71 17.75 6.99 28.38 6.99c18.08 0 33.46-7.64 46.13-22.93l35.23 31.87c-9.51 11.93-21.44 21.07-35.79 27.4-14.36 6.33-30.48 9.51-48.37 9.51-20.51 0-38.91-4.33-55.22-13zM997.46 230.39c-14.92-3.91-27.03-9.13-36.35-15.66l18.17-40.82c8.76 5.78 18.92 10.44 30.48 13.98 11.56 3.54 22.93 5.31 34.11 5.31 21.25 0 31.87-5.31 31.87-15.94 0-5.59-3.03-9.74-9.09-12.44-6.06-2.7-15.8-5.54-29.22-8.53-14.73-3.17-27.03-6.57-36.91-10.21-9.88-3.63-18.36-9.46-25.44-17.47-7.09-8.01-10.62-18.82-10.62-32.43 0-11.93 3.26-22.69 9.79-32.29 6.52-9.6 16.26-17.19 29.22-22.79 12.95-5.59 28.84-8.39 47.67-8.39 12.86 0 25.54 1.45 38.02 4.33 12.49 2.89 23.49 7.13 32.99 12.72l-17.05 41.1c-18.64-10.06-36.72-15.1-54.24-15.1-11 0-19.01 1.63-24.04 4.89-5.03 3.26-7.55 7.51-7.55 12.72 0 5.22 2.98 9.13 8.95 11.74 5.96 2.61 15.56 5.31 28.8 8.11 14.91 3.17 27.26 6.57 37.05 10.21 9.79 3.63 18.26 9.41 25.44 17.33 7.17 7.92 10.76 18.69 10.76 32.29 0 11.74-3.26 22.37-9.79 31.87-6.53 9.51-16.31 17.1-29.36 22.79-13.05 5.68-28.89 8.53-47.53 8.53-15.84.02-31.22-1.94-46.13-5.85z" />
        </svg>
      </Link>
    </Wrapper>
  );
};

export default Logo;
